export default "__VITE_ASSET__CaeVfpit__"